import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-cancel-confirmation-dialog',
    templateUrl: './cancel-confirmation-dialog.component.html',
    styleUrls: ['./cancel-confirmation-dialog.component.css'],
    standalone: false
})
export class CancelConfirmationDialogComponent  implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CancelConfirmationDialogComponent>) {}

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
